module.exports = __webpack_public_path__ + "static/media/dpa.4903c199.jpg";